// Import model
import { DataviewOtgLaminatesCatalogStyleResponse } from '../models/DataviewOtgLaminatesCatalogStyleResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterOtgLaminatesCatalogStyleRequest } from '../models/FilterOtgLaminatesCatalogStyleRequest';
import { OtgLaminatesCatalogStyle } from '../models/OtgLaminatesCatalogStyle';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterOtgLaminatesCatalogStyleRequestSerializer } from './FilterOtgLaminatesCatalogStyleRequestSerializer';
import { OtgLaminatesCatalogStyleSerializer } from './OtgLaminatesCatalogStyleSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewOtgLaminatesCatalogStyleResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewOtgLaminatesCatalogStyleResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewOtgLaminatesCatalogStyleResponse instance
   */
  static deserialize(json: string): DataviewOtgLaminatesCatalogStyleResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewOtgLaminatesCatalogStyleResponse instance
   */
  static fromObject(obj: any): DataviewOtgLaminatesCatalogStyleResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewOtgLaminatesCatalogStyleResponse');
    }


    const instance: DataviewOtgLaminatesCatalogStyleResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        OtgLaminatesCatalogStyleSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterOtgLaminatesCatalogStyleRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewOtgLaminatesCatalogStyleResponse instances
   */
  static deserializeArray(json: string): DataviewOtgLaminatesCatalogStyleResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewOtgLaminatesCatalogStyleResponse instance to a JSON string
   */
  static serialize(instance: DataviewOtgLaminatesCatalogStyleResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewOtgLaminatesCatalogStyleResponse instance to a plain object
   */
  static toObject(instance: DataviewOtgLaminatesCatalogStyleResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        OtgLaminatesCatalogStyleSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterOtgLaminatesCatalogStyleRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewOtgLaminatesCatalogStyleResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewOtgLaminatesCatalogStyleResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
